"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganisationViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.OrganisationViewFields = {
    [ViewFieldKey_1.default.ORG_STATUS]: {
        key: ViewFieldKey_1.default.ORG_STATUS,
        label: () => lib_i18n_1.default.t('org-status'),
        description: () => lib_i18n_1.default.t('org-status-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.ORG_STATUS,
        propertyName: 'status',
        width: 120,
        gqlFields: 'status',
    },
    [ViewFieldKey_1.default.ORG_ONBOARDING_SKIPPED]: {
        key: ViewFieldKey_1.default.ORG_ONBOARDING_SKIPPED,
        label: () => lib_i18n_1.default.t('onboarding-skipped'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'onboardingSkipped',
        width: 150,
        gqlFields: 'onboardingSkipped',
    },
    [ViewFieldKey_1.default.ORG_ONBOARDING_ABANDONED]: {
        key: ViewFieldKey_1.default.ORG_ONBOARDING_ABANDONED,
        label: () => lib_i18n_1.default.t('onboarding-abandoned'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'onboardingAbandoned',
        width: 150,
        gqlFields: 'onboardingAbandoned',
    },
    [ViewFieldKey_1.default.ORG_ONBOARDING_COMPLETED]: {
        key: ViewFieldKey_1.default.ORG_ONBOARDING_COMPLETED,
        label: () => lib_i18n_1.default.t('onboarding-completed'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'onboardingCompleted',
        width: 150,
        gqlFields: 'onboardingCompleted',
    },
    [ViewFieldKey_1.default.ORG_HASCREATED_FIRSTISSUE]: {
        key: ViewFieldKey_1.default.ORG_HASCREATED_FIRSTISSUE,
        label: () => lib_i18n_1.default.t('first-issue-created'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'hasCreatedFirstIssue',
        width: 150,
        gqlFields: 'hasCreatedFirstIssue',
    },
    [ViewFieldKey_1.default.ORG_HASCREATED_FIRSTOPPLAN]: {
        key: ViewFieldKey_1.default.ORG_HASCREATED_FIRSTOPPLAN,
        label: () => lib_i18n_1.default.t('first-operation-created'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'hasCreatedFirstOpPlan',
        width: 150,
        gqlFields: 'hasCreatedFirstOpPlan',
    },
    [ViewFieldKey_1.default.ORG_HASCREATED_FIRSTPOSITION]: {
        key: ViewFieldKey_1.default.ORG_HASCREATED_FIRSTPOSITION,
        label: () => lib_i18n_1.default.t('first-position-created'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'hasCreatedFirstPosition',
        width: 150,
        gqlFields: 'hasCreatedFirstPosition',
    },
    [ViewFieldKey_1.default.ORG_HASCREATED_FIRSTPLACE]: {
        key: ViewFieldKey_1.default.ORG_HASCREATED_FIRSTPLACE,
        label: 'First Place Created',
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'hasCreatedFirstPlace',
        width: 150,
        gqlFields: 'hasCreatedFirstPlace',
    },
    [ViewFieldKey_1.default.ORG_HASCREATED_FIRSTSTAFF]: {
        key: ViewFieldKey_1.default.ORG_HASCREATED_FIRSTSTAFF,
        label: () => lib_i18n_1.default.t('first-staff-created'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'hasCreatedFirstStaff',
        width: 150,
        gqlFields: 'hasCreatedFirstStaff',
    },
    [ViewFieldKey_1.default.ORG_HASCREATED_FIRSTTEAM]: {
        key: ViewFieldKey_1.default.ORG_HASCREATED_FIRSTTEAM,
        label: () => lib_i18n_1.default.t('first-team-created'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'hasCreatedFirstTeam',
        width: 150,
        gqlFields: 'hasCreatedFirstTeam',
    },
    [ViewFieldKey_1.default.ORG_HASCREATED_FIRSTTEAMBOARD]: {
        key: ViewFieldKey_1.default.ORG_HASCREATED_FIRSTTEAMBOARD,
        label: () => lib_i18n_1.default.t('first-teamboard-created'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'hasCreatedFirstTeamboard',
        width: 150,
        gqlFields: 'hasCreatedFirstTeamboard',
    },
    [ViewFieldKey_1.default.ORG_NATIVEAPP_OPENED]: {
        key: ViewFieldKey_1.default.ORG_NATIVEAPP_OPENED,
        label: () => lib_i18n_1.default.t('native-app-opened'),
        sortable: false,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        propertyName: 'nativeAppHasBeenOpened',
        width: 150,
        gqlFields: 'nativeAppHasBeenOpened',
    },
    [ViewFieldKey_1.default.ORG_WEBAPP_ACCESSED]: {
        key: ViewFieldKey_1.default.ORG_WEBAPP_ACCESSED,
        label: () => lib_i18n_1.default.t('web-accessed'),
        sortable: false,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        propertyName: 'webAppHasBeenAccessed',
        width: 150,
        gqlFields: 'webAppHasBeenAccessed',
    },
    [ViewFieldKey_1.default.ORG_ISSETUP]: {
        key: ViewFieldKey_1.default.ORG_ISSETUP,
        label: () => lib_i18n_1.default.t('is-setup'),
        sortable: false,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        propertyName: 'isSetup',
        width: 150,
        gqlFields: 'isSetup',
    },
    [ViewFieldKey_1.default.ORG_TAGS]: {
        key: ViewFieldKey_1.default.ORG_TAGS,
        label: () => lib_i18n_1.default.t('tags'),
        description: () => lib_i18n_1.default.t('org-tags-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.ORG_TAGS,
        propertyName: 'tags',
        width: 120,
        gqlFields: 'tags',
    },
};
exports.default = exports.OrganisationViewFields;
